import {MithrilComponent} from '@bitstillery/mithril'
import {classes, present} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'
import {$s} from '@bitstillery/common/app'

import type {BulkRow, CollectionProxy} from '@bitstillery/common/lib/collection'

/** A row's field by the name the bulk setup's `fields()` gives it; the row type doesn't list them. */
function row_field(row: BulkRow, field_name: string): unknown {
    return Reflect.get(row.item, field_name)
}

interface CollectionBulkColumnAttrs {
    className?: string
    collection: CollectionProxy
    /** The field to process */
    column_id: string
    /** The data from a Collection row */
    row: BulkRow
}

export class CollectionBulkColumn extends MithrilComponent<CollectionBulkColumnAttrs> {
    override oninit(vnode: m.Vnode<CollectionBulkColumnAttrs>) {
        const bulk = present(vnode.attrs.collection.bulk, 'collection bulk')
        for (const field_name of Object.keys(present(bulk._fields[vnode.attrs.row.item.artkey], 'bulk row fields'))) {
            vnode.attrs.row.restore[field_name] = row_field(vnode.attrs.row, field_name)
        }
    }

    override onremove(vnode: m.Vnode<CollectionBulkColumnAttrs>) {
        const bulk = present(vnode.attrs.collection.bulk, 'collection bulk')
        const fields = bulk._fields[vnode.attrs.row.item.artkey]

        if (vnode.attrs.row.changed && !vnode.attrs.row.persist && fields) {
            for (const field_name of Object.keys(fields)) {
                Reflect.set(vnode.attrs.row.item, field_name, vnode.attrs.row.restore[field_name])
            }
        }
        delete bulk.state.rows[vnode.attrs.row.item.artkey]
        delete bulk._fields[vnode.attrs.row.item.artkey]
    }

    view(vnode: m.Vnode<CollectionBulkColumnAttrs>) {
        const bulk = present(vnode.attrs.collection.bulk, 'collection bulk')
        const fields = present(bulk._fields[vnode.attrs.row.item.artkey], 'bulk row fields')
        vnode.attrs.row.changed = Object.keys(fields).some(
            (field_name) => vnode.attrs.row.restore[field_name] !== row_field(vnode.attrs.row, field_name),
        )

        vnode.attrs.row.invalid = Object.values(fields).some((field_value) => field_value?._invalid)

        return (
            <div
                className={classes('c-collection-bulk-column')}
                onclick={(e: MouseEvent) => e.stopPropagation()}
                onkeypress={(e: KeyboardEvent) => {
                    e.stopPropagation()
                    if (vnode.attrs.row.invalid) {
                        return
                    }

                    if (e.key === 'Enter') {
                        void bulk.persist([vnode.attrs.row], $s.env.ctrl_key ? 'alt' : 'default')
                    }
                }}
            >
                {present(bulk.columns[vnode.attrs.column_id], 'bulk column renderer')(vnode.attrs.row, fields)}
            </div>
        )
    }
}
